import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";

interface BirthdayHeaderProps {
  currentPath?: string;
}

export default function BirthdayHeader({ currentPath }: BirthdayHeaderProps) {
  const navItems = [
    { label: "Home", path: "/birthdayreminder" },
    { label: "Privacy", path: "/birthdayreminder/privacy" },
    { label: "Support", path: "/birthdayreminder/support" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between px-4 md:px-8">
        <Link href="/birthdayreminder">
          <a className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
              <Calendar className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg leading-none">Birthday Reminder</span>
              <span className="text-xs text-muted-foreground">Never forget again</span>
            </div>
          </a>
        </Link>

        <nav className="flex items-center space-x-6">
          {navItems.map((item) => (
            <Link key={item.path} href={item.path}>
              <a
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  currentPath === item.path
                    ? "text-foreground"
                    : "text-muted-foreground"
                }`}
              >
                {item.label}
              </a>
            </Link>
          ))}
          <Link href="/birthdayreminder">
            <Button size="sm" className="hidden md:inline-flex">
              Download Free
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}

